import React from 'react';

const MobileContainer = ({ children, className = '' }) => {
  return (
    <div className="min-h-screen bg-white">
      <div className={`max-w-[480px] mx-auto bg-white min-h-screen relative md:shadow-[0_0_40px_rgba(0,0,0,0.08)] ${className}`}>
        {children}
      </div>
    </div>
  );
};

export default MobileContainer;
